import util from '@/utils/util'
import request from '@/utils/request'


export function fetchBillCode(optionName) {
    return request({ url: optionName+'/GetBillCode', method: 'get' });
}

/**
 * 获取采购供应商列表
 */
export function fetchPurchaseSupplier() {
    return request({ url: 'PurchaseSupplier/GetEnabledList', method: 'get' });
}

/**
 * 获取启用的品牌列表
 */
export function fetchPurchaseBrand() {
    return request({ url: 'PurchaseBrand/GetEnabledList', method: 'get' });
}
